export default "__VITE_ASSET__Bv7zTrfz__"